var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.036 512.036",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M485.966 472.967H34.712V21.713c0-9.585-7.771-17.356-17.356-17.356S0 12.127 0 21.713v468.61c0 9.585 7.771 17.356 17.356 17.356h468.61c9.585 0 17.356-7.771 17.356-17.356s-7.77-17.356-17.356-17.356z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.161 128.365 390.508 235.104l-63.262-63.349a8.748 8.748 0 0 0-12.323 0L208.271 278.494l-63.262-63.349a8.748 8.748 0 0 0-12.323 0l-80.618 80.618v24.645l86.78-86.866 63.262 63.349a8.748 8.748 0 0 0 12.323 0l106.652-106.739 63.262 63.349a8.748 8.748 0 0 0 12.323 0l112.814-112.814a8.714 8.714 0 1 0-12.323-12.322z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.453 228.309a5.71 5.71 0 0 0 8.08 0l72.166-75.351a5.726 5.726 0 0 0-4.062-9.754h-28.976V88.03a5.588 5.588 0 0 0-5.571-5.571h-75.637a5.588 5.588 0 0 0-5.571 5.571v55.174h-28.976a5.752 5.752 0 0 0-4.061 9.806zM283.266 386.187h75.637a5.588 5.588 0 0 0 5.571-5.571v-55.174h28.976a5.73 5.73 0 0 0 4.062-9.754l-72.166-75.351a5.71 5.71 0 0 0-8.08 0l-72.609 75.299a5.755 5.755 0 0 0 4.061 9.806h28.976v55.174a5.589 5.589 0 0 0 5.572 5.571z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingIcon);
export default __webpack_public_path__ + "static/media/trading-icon.4a0293dca1527d96ebc593d09b8d96bc.svg";
export { ForwardRef as ReactComponent };